if (!customElements.get('momfree-video-feed')) {
  customElements.define(
    'momfree-video-feed',
    class MomfreeVideoFeed extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mfsvInitialized === 'true') return;
        this.dataset.mfsvInitialized = 'true';

        this.viewport = this.querySelector('[data-mfsv-viewport]');
        this.cards = Array.from(this.querySelectorAll('[data-mfsv-card]'));
        this.previousButton = this.querySelector('[data-mfsv-previous]');
        this.nextButton = this.querySelector('[data-mfsv-next]');
        this.progress = this.querySelector('[data-mfsv-progress]');
        this.modal = this.querySelector('[data-mfsv-modal]');
        this.slides = Array.from(this.querySelectorAll('[data-mfsv-slide]'));
        this.activeIndex = 0;
        this.lastFocusedElement = null;
        this.previousDocumentOverflow = '';
        this.scrollFrame = null;

        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        this.addEventListener('click', this.handleClick);
        this.viewport?.addEventListener('scroll', this.handleScroll, { passive: true });

        this.updateFeedControls();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.viewport?.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('keydown', this.handleKeydown);

        if (this.scrollFrame) {
          cancelAnimationFrame(this.scrollFrame);
        }
      }

      handleClick(event) {
        const openButton = event.target.closest('[data-mfsv-open]');
        if (openButton && this.contains(openButton)) {
          this.openModal(Number(openButton.dataset.mfsvOpen), openButton);
          return;
        }

        const closeButton = event.target.closest('[data-mfsv-close]');
        if (closeButton && this.contains(closeButton)) {
          this.closeModal();
          return;
        }

        if (event.target.closest('[data-mfsv-previous]')) {
          this.scrollFeed(-1);
          return;
        }

        if (event.target.closest('[data-mfsv-next]')) {
          this.scrollFeed(1);
          return;
        }

        if (event.target.closest('[data-mfsv-modal-previous]')) {
          this.showModalSlide(this.activeIndex - 1);
          return;
        }

        if (event.target.closest('[data-mfsv-modal-next]')) {
          this.showModalSlide(this.activeIndex + 1);
          return;
        }

        const quickViewButton = event.target.closest('[data-mfsv-quick-view]');
        if (quickViewButton && this.contains(quickViewButton)) {
          const controlledId = quickViewButton.getAttribute('aria-controls');
          const quickViewModal = controlledId ? document.getElementById(controlledId) : null;
          const quickViewOpener = this.cards
            .map((card) => card.querySelector('[data-mfsv-quick-view]'))
            .find((button) => button?.getAttribute('aria-controls') === controlledId) || quickViewButton;

          const quickViewButton = event.target.closest('[data-mfsv-quick-view]');
if (quickViewButton && this.contains(quickViewButton)) {
  const controlledId = quickViewButton.getAttribute('aria-controls');
  const quickViewModal = controlledId ? document.getElementById(controlledId) : null;

  const quickViewOpener = this.cards
    .map((card) => card.querySelector('[data-mfsv-quick-view]'))
    .find((button) => button?.getAttribute('aria-controls') === controlledId) || quickViewButton;


  if (quickViewModal && typeof quickViewModal.show === 'function') {
    event.preventDefault();
    event.stopPropagation();
    quickViewModal.show(quickViewOpener);
  }
}

          if (quickViewModal && typeof quickViewModal.show === 'function') {
            event.preventDefault();
            event.stopPropagation();
            quickViewModal.show(quickViewOpener);
          }
        }
      }

      handleKeydown(event) {
        if (!this.modal || this.modal.hidden) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeModal();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showModalSlide(this.activeIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showModalSlide(this.activeIndex + 1);
        } else if (event.key === 'Tab') {
          this.trapModalFocus(event);
        }
      }

      handleScroll() {
        if (this.scrollFrame) return;

        this.scrollFrame = requestAnimationFrame(() => {
          this.updateFeedControls();
          this.scrollFrame = null;
        });
      }

      scrollFeed(direction) {
        if (!this.viewport) return;

        const firstCard = this.cards[0];
        const cardWidth = firstCard?.getBoundingClientRect().width || this.viewport.clientWidth * 0.8;
        const track = this.querySelector('.mfsv-feed__track');
        const computedGap = track ? parseFloat(window.getComputedStyle(track).columnGap) || 0 : 0;
        const visibleCards = Math.max(1, Math.floor(this.viewport.clientWidth / (cardWidth + computedGap)));
        const distance = (cardWidth + computedGap) * visibleCards * direction;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.viewport.scrollBy({
          left: distance,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      updateFeedControls() {
        if (!this.viewport) return;

        const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const currentScroll = Math.max(0, this.viewport.scrollLeft);
        const tolerance = 3;

        if (this.previousButton) {
          this.previousButton.disabled = currentScroll <= tolerance;
        }

        if (this.nextButton) {
          this.nextButton.disabled = currentScroll >= maxScroll - tolerance;
        }

        if (this.progress) {
          const progressValue = maxScroll > 0 ? currentScroll / maxScroll : 1;
          this.progress.style.transform = `scaleX(${Math.min(1, Math.max(0, progressValue))})`;
        }
      }

      openModal(index, opener) {
        if (!this.modal || !this.slides.length) return;

        this.lastFocusedElement = opener || document.activeElement;
        this.previousDocumentOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.modal.hidden = false;
        this.showModalSlide(index, { autoplay: true });
        document.addEventListener('keydown', this.handleKeydown);

        requestAnimationFrame(() => {
          this.modal.querySelector('[data-mfsv-close]')?.focus({ preventScroll: true });
        });
      }

      closeModal(options = {}) {
        if (!this.modal || this.modal.hidden) return;

        const { restoreFocus = true } = options;
        this.pauseAllVideos();
        this.modal.hidden = true;
        document.documentElement.style.overflow = this.previousDocumentOverflow;
        document.removeEventListener('keydown', this.handleKeydown);

        if (restoreFocus && this.lastFocusedElement instanceof HTMLElement) {
          this.lastFocusedElement.focus({ preventScroll: true });
        }
      }

      showModalSlide(index, options = {}) {
        if (!this.slides.length) return;

        const normalizedIndex = (index + this.slides.length) % this.slides.length;
        const { autoplay = true } = options;
        this.pauseAllVideos();

        this.slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== normalizedIndex;
        });

        this.activeIndex = normalizedIndex;

        if (autoplay) {
          const activeVideo = this.slides[normalizedIndex]?.querySelector('video');
          const playPromise = activeVideo?.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }
      }

      pauseAllVideos() {
        this.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video) video.pause();
        });
      }

      trapModalFocus(event) {
        const focusableElements = Array.from(
          this.modal.querySelectorAll(
            'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((element) => !element.closest('[hidden]'));

        if (!focusableElements.length) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }
  );
}
